import React from "react";
import withLayout from "../../../components/desktop/layout/component";
import withReducer from "../../../components/shared/with-reducer";
import SellUsedCarSeo from "../../../components/desktop/sell-used-car-seo";
import injectableReducers from "./injectable";

const SellUsedCar = () => {
    return <SellUsedCarSeo showBanner={false} showCarList={true}  topCityKey={"appointment_city"} />;
};

export default withReducer(injectableReducers)(() => ({}), dispatch => ({ dispatch }))(withLayout(SellUsedCar));
